const Home = () => (
    <div className='homeContainer'>
           <h1 className='subTitle'>Welcome to our page</h1>
           <div className='homeDesc'>
            <p> Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Iusto mollitia laborum, dolore obcaecati facilis earum.
                 Quis cupiditate dicta asperiores in cum nam minima
                 at reprehenderit.</p>
            <p> Lorem ipsum dolor sit amet consectetur adipisicing
                 elit. Iusto mollitia laborum, dolore obcaecati facilis
                  earum. Quis cupiditate dicta asperiores in
                   cum nam minima at reprehenderit.</p>
           </div>
    </div>

);

export default Home;